import React, { Component } from 'react';
import { DropdownButton, ProgressBar, MenuItem } from 'react-bootstrap';
import authService from './api-authorization/AuthorizeService';


export class SecondModel extends Component {
    displayName = SecondModel.name

    constructor(props) {
        super(props);
        this.state = {
            currentCount: 0,
            name: "",
            category: "Без категории",
            chapter: "Новости",
            tag: "",
            n_symbols: "1000",
            result: "0",
            loading: false,
            token: null,
            button: "Результаты",
            categories: ["Без категории", "Происшествия", "Личные финансы", "В мире", "Технологии", "Спорт", "Наука", "Культура",
                "Регионы", "Шоубиз", "Эксклюзивы", "Авто", "Армия", "Политика", "Общество", "Здоровье", "История", "Россия", "Экономика",
                "Коронавирус", "Криминал", "Поп-культура и Развлечения", "Наука и Технологии", "Интересное"],
            selectedCategories: []
        };
        this.incrementCounter = this.incrementCounter.bind(this);
        this.setName = this.setName.bind(this);
        this.setCategory = this.setCategory.bind(this);
        this.setChapter = this.setChapter.bind(this);
        this.getResult = this.getResult.bind(this);
        this.setTag = this.setTag.bind(this);
        this.setCount = this.setCount.bind(this);
        this.removeCategory = this.removeCategory.bind(this);

    }
    async setInitialState() {
        const token = await authService.getAccessToken(); 
        this.setState({ token: token });
        console.log(token);
    }
    componentDidMount() {
        this.setInitialState();
    }
    incrementCounter() {
        this.setState({
            currentCount: this.state.currentCount + 1
        });
    }
    setName(str) {
        this.setState({ name: str });
    }
    setCategory(str) {
        var tempt = this.state.selectedCategories;
        tempt.push(str);
        var temptCategories = this.state.categories;
        const index = temptCategories.indexOf(str);
        if (index > -1) {
            temptCategories.splice(index, 1);
        }
        this.setState({ category: str, selectedCategories: tempt, categories: temptCategories });
    }
    removeCategory(str) {
        var tempt = this.state.categories;
        tempt.push(str);
        var temptSelected = this.state.selectedCategories;
        const index = temptSelected.indexOf(str);
        if (index > -1) {
            temptSelected.splice(index, 1);
        }
        this.setState({ category: str, selectedCategories: temptSelected, categories: tempt });
    }
    setChapter(str) {
        this.setState({ chapter: str });
    }
    setTag(str) {
        this.setState({ tag: str });
    }
    setCount(str) {
        this.setState({ n_symbols: str });
    }
    getResult() {
        this.setState({ loading: true, button: "..progress" });

        fetch('api/data/start', {
            method: 'post',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                name: this.state.name,
                n_symbols: this.state.n_symbols,
                category: this.state.selectedCategories.join(","),
                chapter: this.state.chapter,
                tag: this.state.tag
            })
        }).then(response => response.json())
            .then(data => {
                this.setState({ result: data.result, loading: false, button: "Результаты" });
            });
    }

    render() {
        var categories = <DropdownButton title={this.state.category}>
            {this.state.categories.map(x => <MenuItem onClick={(e) => this.setCategory(x)}>{x}</MenuItem>)}
        </DropdownButton>;
        var selectedCategories = this.state.selectedCategories.map(x => <button onClick={(e) => this.removeCategory(x)} className="badge badge-pill badge-primary">{x}</button>)
        return (
            <div className="col-md-11">
                <h1>Прогнозная модель</h1>
                <h3>Языковая модель BERT</h3>
                <div className="row form-group">
                    <textarea name="name" placeholder="Название статьи" className="form-control" type="text" value={this.state.name} onChange={(e) => this.setName(e.target.value)}></textarea>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <h4>Категории:</h4>
                    </div>
                    <div className="col-md-2">
                        {categories}
                    </div>
                    <div className="col-md-1">
                    </div>
                    <div className="col-md-7">
                        {selectedCategories}
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <h4>Раздел:</h4>
                    </div>
                    <div className="col-md-2">
                        <DropdownButton title={this.state.chapter}>
                            <MenuItem onClick={(e) => this.setChapter("Новости")}>Новости</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Расследования")}>Расследования</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Статьи")}>Статьи</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Wow")}>Wow</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Дичь")}>Дичь</MenuItem>
                        </DropdownButton>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <h4>Теги:</h4>
                    </div>
                    <div className="col-md-6">
                        <input placeholder="Теги, через запятую" className="form-control" type="text" value={this.state.tag} onChange={(e) => this.setTag(e.target.value)}></input>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <h4>Cимволов: </h4>
                    </div>
                    <div className="col-md-2">
                        <input placeholder="" className="form-control" type="number" value={this.state.n_symbols} onChange={(e) => this.setCount(e.target.value)}></input>
                    </div>
                </div>
                <button className="button" onClick={this.getResult} disabled={this.state.loading}>{this.state.button}</button>
                <br></br>
                <div className="row form-group" style={{ marginTop: '40px' }}>
                    <div className="col-md-4">
                        <h4>Количество просмотров:</h4>
                    </div>
                    <div className="col-md-1 form-control">
                        <strong>{this.state.result}</strong>
                    </div>
                </div>
                <div className="row form-group" style={{ marginTop: '40px' }}>
                    <div className="col-md-2">
                        <h4>Переходы из рекомендательных систем:</h4>
                    </div>
                    <div className="col-md-10">
                        <ProgressBar animated now={45} />
                    </div>
                </div>
                <div className="row form-group" >
                    <div className="col-md-2">
                        <h4>Переходы из поисковых систем:</h4>
                    </div>
                    <div className="col-md-10">
                        <ProgressBar animated now={55} />
                    </div>
                </div>
                <div className="row form-group" >
                    <div className="col-md-2">
                        <h4>Переходы по ссылкам на сайтах:</h4>
                    </div>
                    <div className="col-md-10">
                        <ProgressBar animated now={65} />
                    </div>
                </div>
                <div className="row form-group" >
                    <div className="col-md-2">
                        <h4>Прямые заходы:</h4>
                    </div>
                    <div className="col-md-10">
                        <ProgressBar animated now={75} />
                    </div>
                </div>
        
            </div>
        );
    }

//                            <DropdownButton title={this.state.category}>
//    <MenuItem onClick={(e) => this.setCategory("Без категории")}>Без категории</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Происшествия")}>Происшествия</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Личные финансы")}>Личные финансы</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("В мире")}>В мире</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Технологии")}>Технологии</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Спорт")}>Спорт</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Наука")}>Наука</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Культура")}>Культура</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Регионы")}>Регионы</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Шоубиз")}>Шоубиз</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Эксклюзивы")}>Эксклюзивы</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Авто")}>Авто</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Армия")}>Армия</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Политика")}>Политика</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Общество")}>Общество</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Здоровье")}>Здоровье</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("История")}>История</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Россия")}>Россия</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Экономика")}>Экономика</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Коронавирус")}>Коронавирус</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Криминал")}>Криминал</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Поп-культура и Развлечения")}>Поп-культура и Развлечения</MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Наука и Технологии")}>Наука и Технологии </MenuItem>
//    <MenuItem onClick={(e) => this.setCategory("Интересное ")}>Интересное </MenuItem>
//</DropdownButton>
}



// WEBPACK FOOTER //
// ./src/components/SecondModel.js